import { Controller } from "@hotwired/stimulus"

// Google Places autocomplete for location fields
// Values: model, field, location, latitude, longitude, explanation, required (boolean)
// Targets: input, lat, lng
export default class extends Controller {
  static values = { model: String, field: String, explanation: String, required: Boolean }
  static targets = ["input", "lat", "lng"]

  connect() {
    if (typeof google !== "undefined" && google.maps && google.maps.places) {
      this.initAutocomplete()
    } else {
      // Google Maps may not be loaded yet — try on load, or poll briefly
      const handler = () => {
        window.removeEventListener("load", handler)
        this.initAutocomplete()
      }
      window.addEventListener("load", handler)

      // Also poll in case load already fired (Turbo navigation)
      this.pollCount = 0
      this.pollTimer = setInterval(() => {
        this.pollCount++
        if (typeof google !== "undefined" && google.maps && google.maps.places) {
          clearInterval(this.pollTimer)
          window.removeEventListener("load", handler)
          this.initAutocomplete()
        } else if (this.pollCount > 20) {
          clearInterval(this.pollTimer)
        }
      }, 250)
    }
  }

  disconnect() {
    if (this.pollTimer) clearInterval(this.pollTimer)
  }

  initAutocomplete() {
    if (!this.hasInputTarget) return
    if (this.autocomplete) return // already initialized

    try {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.inputTarget,
        { types: ["geocode"], fields: ["geometry"] }
      )

      this.autocomplete.addListener("place_changed", () => {
        const place = this.autocomplete.getPlace()
        if (place && place.geometry) {
          this.latTarget.value = place.geometry.location.lat()
          this.lngTarget.value = place.geometry.location.lng()
        }
      })
    } catch (e) {
      console.warn("Google Places autocomplete failed to initialize:", e)
    }
  }
}
